module.exports = __webpack_public_path__ + "static/media/iVIP.f736afe3.svg";